import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"10px","text-align":"left"} }
const _hoisted_2 = { style: {"padding":"20px"} }

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allDomainName, addDomainName,reviseDomainNameType,reviseDomainNameState,delDomainName,allPlatform,domainNamePlatform } from '../../api'
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const search = reactive({
    type: "0",
    state: "0",
  })

  const platformArr = ref([]); 
    //平台
    const getAllPlatform = () => { 
    var data = {};
    allPlatform(JSON.stringify(data)).then((res: any) => { 
      if (res != "" && res.code == 0) {
        platformArr.value = res.data; 
      } else {
        platformArr.value = []; 
      }
    })
  }

  getAllPlatform();
  
  
  const loading = ref(false);


  const dataSource = ref([]);
 
  
  const selectedKeys = ref([]);
  
  const page = reactive({ current: 1, limit: 10, total: 0 });
  
  const columns = ref([
    { title: "ID", width: "60px", key: "id", align: "center" },
    { title: "域名", key: "domainName", align: "center" },
    { title: "平台", key: "name", align: "center" },
    { title: "类型", key: "type", align: "center", customSlot: "type" },
    { title: "状态", key: "state", align: "center", customSlot: "state" },
    { title: "备注", key: "remark", align: "center" },
    { title: "时间", key: "addTime", align: "center" },
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
  ]);
  
  
  const getAllDomainName = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit, "type": search.type,"state": search.state };
    allDomainName(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }

  getAllDomainName();
  
  const change = (page: any) => {
    getAllDomainName();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  
//域名修改平台
const  changePlatform=(row: any,id:any)=>{
  var data = { "id": row.id, "key": id };
    domainNamePlatform(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
        getAllDomainName();
      layer.msg("操作成功", { time: 1000, icon: 1 });
    }
  })
}




  //查询接口
  const searchUser = () => {
    page.current=1;
    getAllDomainName();
  }
  
  //修改状态接口

  const changeState = (row: any,state:any) => { 
  var data = { "key": row.id, "id": state };
    reviseDomainNameState(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
        getAllDomainName();
      layer.msg("操作成功", { time: 1000, icon: 1 });
    }
  })
}
  //修改类型接口
  const changeType = (row: any,type:any) => { 
  var data = { "key": row.id, "id":type };
  reviseDomainNameType(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
        getAllDomainName();
      layer.msg("操作成功", { time: 1000, icon: 1 });
    }
  })
}
  
  
  const domain = reactive({
    id:0,
    domainName: "",
    type: "",
    state: "", 
    remark:"",
    platformId:"",
  })
  
  
  const deledomainName = (row: any) => {
       var data={'id':row.id} 
    delDomainName(JSON.stringify(data)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllDomainName(); 
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
   
  }
  
  const layFormRef11 = ref();
  
  const visible11 = ref(false);
  
  const isDisabled = ref(false);
  
  const changeVisible11 = () => {
    domain.id = 0;
    domain.domainName = "";
    domain.type = "";
    domain.state = "";
    domain.remark = ""; 
    domain.platformId="";
    isDisabled.value = false;
    visible11.value = !visible11.value;
  }
  
  const action11 = ref([
    {
      text: "确认",
      callback: () => {
        addDomainName(JSON.stringify(domain)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllDomainName();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
      }
    },
    {
      text: "取消",
      callback: () => {
        visible11.value = false;
      }
    }
  ])
  
  
  
return (_ctx: any,_cache: any) => {
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_textarea = _resolveComponent("lay-textarea")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_form, {
                  model: search,
                  style: {"text-align":"start"},
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form_item, {
                      label: "类型",
                      prop: "type",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_select, {
                          modelValue: search.type,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.type) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_select_option, {
                              value: "0",
                              label: "全部"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "1",
                              label: "301域名"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "2",
                              label: "跳板推广"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "3",
                              label: "主站域名"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "4",
                              label: "下载地址"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "状态",
                      prop: "state",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_select, {
                          modelValue: search.state,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.state) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_select_option, {
                              value: "0",
                              label: "全部"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "1",
                              label: "未使用"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "2",
                              label: "使用中"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, { mode: "inline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_button, {
                          type: "primary",
                          size: "sm",
                          onClick: searchUser
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_lay_button, {
                    size: "sm",
                    onClick: changeVisible11,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[2] || (_cache[2] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  type: _withCtx(({ row }) => [
                    _createVNode(_component_lay_select, {
                      modelValue: row.type,
                      "onUpdate:modelValue": ($event: any) => ((row.type) = $event)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_select_option, {
                          value: "1",
                          label: "防墙推广域名",
                          onClick: ($event: any) => (changeType(row,1))
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_lay_select_option, {
                          value: "2",
                          label: "普通推广域名",
                          onClick: ($event: any) => (changeType(row,2))
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_lay_select_option, {
                          value: "3",
                          label: "防墙下载域名",
                          onClick: ($event: any) => (changeType(row,3))
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_lay_select_option, {
                          value: "4",
                          label: "普通下载域名",
                          onClick: ($event: any) => (changeType(row,4))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  state: _withCtx(({ row }) => [
                    _createVNode(_component_lay_select, {
                      modelValue: row.state,
                      "onUpdate:modelValue": ($event: any) => ((row.state) = $event)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_select_option, {
                          value: "1",
                          label: "未使用",
                          onClick: ($event: any) => (changeState(row,1))
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_lay_select_option, {
                          value: "2",
                          label: "使用中",
                          onClick: ($event: any) => (changeState(row,2))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  operator: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "danger",
                      onClick: ($event: any) => (deledomainName(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['390px', '500px'],
      btn: action11.value,
      title: "添加/修改"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_lay_form, {
            model: domain,
            ref_key: "layFormRef11",
            ref: layFormRef11,
            required: "",
            pane: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "域名",
                prop: "domainName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: domain.domainName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((domain.domainName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "类型",
                prop: "type",
                mode: "inline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_select, {
                    modelValue: domain.type,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((domain.type) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select_option, {
                        value: 1,
                        label: "防墙推广域名"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 2,
                        label: "普通推广域名"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 3,
                        label: "防墙下载域名"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 4,
                        label: "普通下载域名"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "状态",
                prop: "state",
                mode: "inline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_select, {
                    modelValue: domain.state,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((domain.state) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select_option, {
                        value: 1,
                        label: "未使用"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 2,
                        label: "使用中"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "平台",
                prop: "platformId",
                mode: "inline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_select, {
                    modelValue: domain.platformId,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((domain.platformId) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platformArr.value, (platform) => {
                        return (_openBlock(), _createBlock(_component_lay_select_option, {
                          value: platform.id,
                          label: platform.name
                        }, null, 8, ["value", "label"]))
                      }), 256))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "备注",
                prop: "remark"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_textarea, {
                    placeholder: "请输入备注",
                    modelValue: domain.remark,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((domain.remark) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})